import { ElectricLoad } from '../../../../../../domain/ElectricLoad';
import type { Percent } from '../../../../../../domain/Percent';
import { AttentionStatus } from '../../../../../AttentionStatus';
import { EvaluationResult } from '../../../../../EvaluatedResult';
import type { EvaluationResultType } from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class LoadingPercentEvaluation {
  private readonly ruleName = 'Lv_PowerTransformer_LoadingPercent';

  constructor(private readonly rulesProvider: ForRuleProviding) {}

  public evaluate(loading: Percent): EvaluationResultType<ElectricLoad> {
    const rule = this.rulesProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(
      rule?.value,
      loading.toNumber()
    );
    const value = ElectricLoad.fromPercent(loading);
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
